import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var pill = function pill() {
  var hover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var pillColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'neutral';
  return /*#__PURE__*/css("width:fit-content;border-radius:100px;display:flex;flex-direction:row;align-items:center;padding:2px 8px;gap:4px;color:", colors[pillColor].heavy.default, ";background-color:", colors[pillColor].subdued.default, ";", hover && /*#__PURE__*/css("background-color:", colors[pillColor].subdued.hover, ";"));
};
export var label = /*#__PURE__*/css(applyFont(typography.miniBold), ";white-space:nowrap;");
export var value = /*#__PURE__*/css(applyFont(typography.mini), ";white-space:nowrap;");